import React from 'react'
import DashboardPage from './DashboardPage'

const FoodsPage = () => {
  return (
    <DashboardPage>
        FoodsPage
        
    </DashboardPage>
  )
}

export default FoodsPage